/**
 * @fileOverview reporting.standard.component.ts - Standard Report
 * @author Ivelin Ivanov
 */
var bindsTo = { vm: '=' };
var ReportingStandardController = (function () {
    function ReportingStandardController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.newSearch = 'Default';
        /* Component items */
        this.visibleStandard = false;
        this.openItems = false;
        this.closeItems = false;
        this.showTable = false;
        this.loadedOn = new Date();
        this.currFilter = [];
        this.dtInstance = {};
        this.checkBoxModel = {};
        this.queryId = this.$stateParams.id;
        this.isDownloading = false;
        this.filters = {};
        this.filterIots = [];
        this.filterImts = [];
        this.filterCountries = [];
        this.filterSviStatuses = [];
        this.filterStatuses = [];
        this.filterSubStatuses = [];
        this.filterOwners = [];
        this.teams = [];
        this.filterTeams = [];
        this.vapFilter = false;
        this.showFilterBtn = false;
        this.demo = {
            isOpen: false,
            count: 0,
            selectedDirection: 'right'
        };
        this.filterDetails();
        this.socket.forward('filters.getUserFilters', this.$scope);
        this.$scope.$on('socket:filters.getUserFilters', function (event, data) {
            _this.userFilters = data;
            _this.filtersExist = true;
        });
        this.socket.forward('filters.deleteProfiles', this.$scope);
        this.$scope.$on('socket:filters.deleteProfiles', function (event, data) {
            _this.userFilters = data;
            _this.allowed = false;
        });
        this.socket.forward('queue.exportQueue', this.$scope);
        this.$scope.$on('socket:queue.exportQueue', function (event, data) {
            _this.isDownloading = false;
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-STANDARD-Report_" + d + ".xlsx");
                a.click();
            }
        });
        this.isTeamQueue = false;
        this.showMassAsignment = false;
        this.filterToggles = {
            countries: true,
            sviStats: true,
            dmtStats: true,
            dmtSubStats: true,
            teams: false,
            vap: true
        };
    }
    ReportingStandardController.prototype.$onInit = function () {
        var that = this;
        this.dtColumns = this.buildColumns();
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withOption('ajax', {
            dataSrc: function (data) {
                that.checkBoxModel = {};
                data.data.forEach(function (dmtRec) {
                    that.checkBoxModel[dmtRec.opp] = false;
                });
                return data.data;
            },
            url: '/api/queue',
            type: 'POST',
            beforeSend: function (request) {
                request.setRequestHeader('Authorization', 'Bearer ' + that.env.user.token);
            },
            data: function (d) {
                var searchCountries = '';
                if (that.filterCountries) {
                    for (var _i = 0, _a = that.filterCountries; _i < _a.length; _i++) {
                        var item = _a[_i];
                        searchCountries += item + '|';
                    }
                    searchCountries = searchCountries.substring(0, searchCountries.length - 1);
                }
                var searchSviStat = '';
                if (that.filterSviStatuses) {
                    for (var _b = 0, _c = that.filterSviStatuses; _b < _c.length; _b++) {
                        var item = _c[_b];
                        searchSviStat += item + '|';
                    }
                    searchSviStat = searchSviStat.substring(0, searchSviStat.length - 1);
                }
                var searchDmtStat = '';
                if (that.filterStatuses) {
                    for (var _d = 0, _e = that.filterStatuses; _d < _e.length; _d++) {
                        var item = _e[_d];
                        searchDmtStat += item + '|';
                    }
                    searchDmtStat = searchDmtStat.substring(0, searchDmtStat.length - 1);
                }
                var searchSubStat = '';
                if (that.filterSubStatuses) {
                    for (var _f = 0, _g = that.filterSubStatuses; _f < _g.length; _f++) {
                        var item = _g[_f];
                        searchSubStat += item + '|';
                    }
                    searchSubStat = searchSubStat.substring(0, searchSubStat.length - 1);
                }
                var searchOwner = '';
                if (that.filterOwners) {
                    for (var _h = 0, _j = that.filterOwners; _h < _j.length; _h++) {
                        var item = _j[_h];
                        searchOwner += item + '|';
                    }
                    searchOwner = searchOwner.substring(0, searchOwner.length - 1)
                        .replace('(', '\\(').replace(')', '\\)');
                }
                var searchTeam = '';
                if (that.filterTeams.length) {
                    for (var _k = 0, _l = that.filterTeams; _k < _l.length; _k++) {
                        var item = _l[_k];
                        searchTeam += item + '|';
                    }
                    searchTeam = searchTeam.substring(0, searchTeam.length - 1);
                    d.columns.push({
                        data: 'team', name: 'team', orderable: false,
                        search: { regex: true, value: searchTeam }, searchable: false
                    });
                }
                for (var _m = 0, _o = d.columns; _m < _o.length; _m++) {
                    var col = _o[_m];
                    if (searchCountries !== '' && col.name === 'country') {
                        col.search.regex = true;
                        col.search.value = searchCountries;
                    }
                    if (searchDmtStat !== '' && col.name === 'status') {
                        col.search.regex = true;
                        col.search.value = searchDmtStat;
                    }
                    if (searchSubStat !== '' && col.name === 'substatus') {
                        col.search.regex = true;
                        col.search.value = searchSubStat;
                    }
                    if (searchOwner !== '' && col.name === 'owner') {
                        col.search.regex = true;
                        col.search.value = searchOwner;
                    }
                    if (searchSviStat !== '' && col.name === 'svistat') {
                        col.search.regex = true;
                        col.search.value = searchSviStat;
                    }
                }
                d.iotFilter = that.filterIots;
                d.imtFilter = that.filterImts;
                d.queueType = 'standardreport';
                d.vapFilter = that.vapFilter;
                d.users = [("" + that.env.user.email)];
            }
        })
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('order', [4, 'asc'])
            .withPaginationType('full_numbers')
            .withOption('createdRow', createdRow);
        function createdRow(row, data, dataIndex) {
            var OFFSET = 3;
            var thresholdDate = new Date();
            thresholdDate.setHours(0, 0, 0, 0);
            thresholdDate.setDate(thresholdDate.getDate() - OFFSET);
            var createdOn = new Date(parseInt(data.created, 10));
            createdOn.setHours(0, 0, 0, 0);
            if (createdOn <= thresholdDate && data.substatus === 'Unassigned') {
                $(row).addClass('tblRow').css('color', 'red');
            }
            else {
                $(row).addClass('tblRow');
            }
            var el = angular.element;
            that.$compile(el(row).contents())(that.$scope);
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'FetchSavedFilters',
                script: '/queueservice/filterprofiles',
                user: this.env.user
            }
        });
    };
    ReportingStandardController.prototype.toggleStandard = function () {
        if (this.visibleStandard) {
            this.visibleStandard = false;
        }
        else {
            this.visibleStandard = true;
        }
    };
    ReportingStandardController.prototype.toggleOpenItems = function () {
        if (this.openItems) {
            this.openItems = false;
        }
        else {
            this.openItems = true;
        }
    };
    ReportingStandardController.prototype.toggleClosedItems = function () {
        if (this.closeItems) {
            this.closeItems = false;
        }
        else {
            this.closeItems = true;
        }
    };
    ReportingStandardController.prototype.toggleDownload = function () {
        this.isDownloading = true;
    };
    ReportingStandardController.prototype.loadReport = function () {
        if (!this.showTable) {
            this.showTable = true;
        }
        else {
            this.showTable = false;
        }
        var that = this;
        this.dtInstance.DataTable.ajax.reload();
    };
    ReportingStandardController.prototype.buildColumns = function () {
        var that = this;
        var columns = [
            this.DTColumnBuilder.newColumn('opp').withTitle('Opportunity')
                .withOption('name', 'opp').renderWith(this.linkUrl),
            this.DTColumnBuilder.newColumn('imt')
                .withOption('name', 'imt').withTitle('IMT'),
            this.DTColumnBuilder.newColumn('iot').withOption('name', 'iot').withTitle('IOT'),
            this.DTColumnBuilder.newColumn('country').withOption('name', 'country')
                .withTitle('Country'),
            this.DTColumnBuilder.newColumn('svistat').withTitle('MySA Status')
                .withOption('name', 'svistat'),
            this.DTColumnBuilder.newColumn('status').withOption('name', 'status')
                .withTitle('DMT Status'),
            this.DTColumnBuilder.newColumn('substatus').withOption('name', 'substatus')
                .withTitle('DMT Substatus'),
            this.DTColumnBuilder.newColumn('crncy').
                withOption('name', 'crncy').withTitle('Currency'),
            this.DTColumnBuilder.newColumn('bfamily')
                .withOption('name', 'bfamily').withTitle('Brand Family'),
            this.DTColumnBuilder.newColumn('bp')
                .withOption('name', 'bp').withTitle('BP'),
            this.DTColumnBuilder.newColumn('acnt')
                .withOption('name', 'acnt').withTitle('ACNT'),
        ];
        return columns;
    };
    ReportingStandardController.prototype.linkUrl = function (data, type, full, meta) {
        return '<a class="ibm-ind-link" href="" ng-click="vm.edit(' + meta.row + ')">' + data + '</a>';
    };
    ReportingStandardController.prototype.actionsHtml = function (data, type, full, meta) {
        if (this.$stateParams.id === 'workitems') {
            return "<span>\n                    <md-icon md-svg-icon=\"forbidden\"/>\n                  </span>";
        }
        else {
            return "<span>\n                <md-icon class=\"expand\" md-svg-icon=\"expand\" ng-click=\"vm.expand()\"/>\n              </span>\n              <span>\n                <md-icon class=\"collapse ng-hide\" md-svg-icon=\"collapse\" ng-click=\"vm.expand()\"/>\n              </span>";
        }
    };
    ReportingStandardController.prototype.filterDetails = function () {
        var _this = this;
        this.env.topics.imtFilterValues = this.settings.country_list;
        this.filters.iots = this.settings.iot_list;
        this.filters.imts = this.settings.imt_list;
        this.filters.countries = this.settings.getCountryList();
        this.filters.iots.sort();
        this.filters.imts.sort();
        this.filters.countries.sort();
        this.env.topics.imtFilterValues.forEach(function (value) {
            if (value.ic === 'IOT') {
                if (!_.includes(_this.filters.iots, value.imt)) {
                    _this.filters.iots.push(value.imt);
                }
            }
            else if (value.ic === 'IMT') {
                if (!_.includes(_this.filters.imts, value.imt_name)) {
                    _this.filters.imts.push(value.imt_name);
                }
            }
            else {
                if (!_.includes(_this.filters.countries, value.country)) {
                    _this.filters.countries.push(value.country);
                }
            }
        });
        this.filters.sviStatuses = this.settings.svistatuses;
        this.filters.statuses = this.settings.statuses;
        this.filters.subStatuses = this.settings.substatuses;
        this.showFilterBtn = true;
    };
    ReportingStandardController.prototype.changeFilters = function (id) {
        var _this = this;
        if (id === 'iot') {
            this.filterImts = [];
            this.filterCountries = [];
            this.filters.imts = [];
            this.filters.countries = [];
            this.env.topics.imtFilterValues.forEach(function (value) {
                if (value.ic === 'IMT') {
                    if (_.includes(_this.filterIots, value.imt) &&
                        !_.includes(_this.filters.imts, value.imt_name)) {
                        _this.filters.imts.push(value.imt_name);
                    }
                }
                else if (value.ic === 'Country') {
                    if (_.includes(_this.filterIots, value.imt) &&
                        !_.includes(_this.filters.countries, value.country)) {
                        _this.filters.countries.push(value.country);
                    }
                }
            });
            this.filters.imts.sort();
            this.filters.countries.sort();
        }
        else if (id === 'imt') {
            this.filterCountries = [];
            this.filters.countries = [];
            this.env.topics.imtFilterValues.forEach(function (value) {
                if (value.ic === 'Country') {
                    if (_.includes(_this.filterImts, value.imt_name) &&
                        !_.includes(_this.filters.countries, value.country)) {
                        _this.filters.countries.push(value.country);
                    }
                }
            });
        }
        var test = 1 + 1;
        //If the 'last used filter' is still active, re-add the values as they will have been lost
        // by the code above
        if (this.settings.up.lastFilter) {
            this.applyLastFilter(); //reset the values
        }
    };
    ReportingStandardController.prototype.applyLastFilter = function () {
        var _this = this;
        //If there is a lastFilter element in user's profile (in browser), set the
        // filters accordingly and apply them rather than loading the default (all)
        if (this.settings.up.lastFilter) {
            angular.forEach(this.settings.up.lastFilter, function (v, k) {
                _this[k] = v;
            });
            this.isFilterToggled = true;
        }
    };
    ReportingStandardController.prototype.toggleFilter = function () {
        if (this.isFilterToggled) {
            this.applyFilter();
        }
        this.isFilterToggled = !this.isFilterToggled;
    };
    ReportingStandardController.prototype.applyFilter = function () {
        if (this.filterSubStatuses.length ||
            this.filterTeams.length ||
            this.filterStatuses.length ||
            this.filterCountries.length ||
            this.filterOwners.length ||
            this.filterSviStatuses.length ||
            this.filterImts.length ||
            this.filterIots.length ||
            this.vapFilter) {
            this.isFilterSet = true;
        }
        else {
            this.isFilterSet = false;
        }
        this.dtInstance.DataTable.ajax.reload();
    };
    ReportingStandardController.prototype.clearFilter = function () {
        this.isFilterSet = false;
        this.vapFilter = false;
        this.filterSubStatuses = [];
        this.filterStatuses = [];
        this.filterOwners = [];
        this.filterCountries = [];
        this.filterSviStatuses = [];
        this.filterTeams = [];
        this.filterImts = [];
        this.filterIots = [];
        this.dtInstance.DataTable.ajax.reload();
    };
    ReportingStandardController.prototype.saveFilter = function () {
        var filterFound = false;
        if (typeof this.userFilters !== 'undefined') {
            for (var i = 0; i < this.userFilters.length; i++) {
                if (this.userFilters[i].name === this.newSearch) {
                    filterFound = true;
                    this.userFilters[i].vapFilter = this.vapFilter;
                    this.userFilters[i].filterSubStatuses = this.filterSubStatuses;
                    this.userFilters[i].filterStatuses = this.filterStatuses;
                    this.userFilters[i].filterOwners = this.filterOwners;
                    this.userFilters[i].filterCountries = this.filterCountries;
                    this.userFilters[i].filterSviStatuses = this.filterSviStatuses;
                    this.userFilters[i].filterTeams = this.filterTeams;
                    this.userFilters[i].filterImts = this.filterImts;
                    this.userFilters[i].filterIots = this.filterIots;
                    break;
                }
            }
        }
        if (!filterFound) {
            var saveSearchObj = {};
            saveSearchObj.name = this.newSearch;
            saveSearchObj.vapFilter = this.vapFilter;
            saveSearchObj.filterSubStatuses = this.filterSubStatuses;
            saveSearchObj.filterStatuses = this.filterStatuses;
            saveSearchObj.filterOwners = this.filterOwners;
            saveSearchObj.filterCountries = this.filterCountries;
            saveSearchObj.filterSviStatuses = this.filterSviStatuses;
            saveSearchObj.filterTeams = this.filterTeams;
            saveSearchObj.filterImts = this.filterImts;
            saveSearchObj.filterIots = this.filterIots;
            if (typeof this.userFilters !== 'undefined') {
                this.userFilters.push(saveSearchObj);
            }
            else {
                this.userFilters = [saveSearchObj];
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'SaveFilter',
                script: '/queueservice/filterprofiles',
                user: this.env.user,
                data: this.userFilters
            }
        });
    };
    ReportingStandardController.prototype.changeSavedFilter = function (filter) {
        this.currFilter = filter;
        this.filterIots = filter.filterIots;
        this.filterImts = filter.filterImts;
        this.filterCountries = filter.filterCountries;
        this.filterSviStatuses = filter.filterSviStatuses;
        this.filterStatuses = filter.filterStatuses;
        this.filterSubStatuses = filter.filterSubStatuses;
        this.filterOwners = filter.filterOwners;
        this.filterTeams = filter.filterTeams;
    };
    ReportingStandardController.prototype.deleteProfile = function (profile) {
        this.allowed = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'deleteProfile',
                script: '/queueservice/filterprofiles',
                user: this.env.user.email,
                data: profile,
                token: this.env.user.token
            }
        });
    };
    ReportingStandardController.prototype.download = function () {
        this.isDownloading = true;
        var data = {
            queryId: 'standardreport',
            filterTeams: this.filterTeams,
            filterOwners: this.filterOwners,
            filterSubStatuses: this.filterSubStatuses,
            filterStatuses: this.filterStatuses,
            filterSviStatuses: this.filterSviStatuses,
            filterIots: this.filterIots,
            filterImts: this.filterImts,
            filterCountries: this.filterCountries,
            vapFilter: this.vapFilter
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportQueue',
                script: 'queueservice/excelbuilder',
                data: {
                    filters: data,
                    userId: this.env.user.email
                },
                token: this.env.user.token
            }
        });
    };
    ReportingStandardController.$inject = ['$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings'];
    return ReportingStandardController;
}());
var ReportingStandardComponent = (function () {
    function ReportingStandardComponent() {
        this.bindings = bindsTo;
        this.templateUrl = 'report.standard.html';
        this.controller = ReportingStandardController;
    }
    return ReportingStandardComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('clearAll', '/public/icons/ic_clear_all_black_18px.svg');
})
    .component('reportStandard', new ReportingStandardComponent());

//# sourceMappingURL=reporting.standard.component.js.map
